'use client';

import React from 'react';

import { AVATAR_SIZE } from '@depop/web-ui-kit/Avatar';
import { useResponsive } from '@depop/web-ui-kit/useResponsive';

import { AvatarWithLink } from '@/components/AvatarWithLink';

type AvatarLinkProps = React.ComponentProps<typeof AvatarWithLink>;

type Props = {
  isCompact?: boolean;
} & Pick<AvatarLinkProps, 'src' | 'href' | 'initials' | 'verified' | 'alt'>;

export function ShopSummaryAvatar({ isCompact, ...rest }: Props) {
  const { isMaxMedium } = useResponsive();

  function getAvatarSize() {
    if (isCompact) {
      return AVATAR_SIZE.EXTRA_SMALL;
    }
    if (isMaxMedium) {
      return AVATAR_SIZE.SMALL;
    }
    return AVATAR_SIZE.MEDIUM;
  }

  return <AvatarWithLink {...rest} size={getAvatarSize()} />;
}
